// extracted by mini-css-extract-plugin
export default {"photo":"Photo_photo__HTJvk","rotatePhoto":"Photo_rotatePhoto__qY2p3","attach":"Photo_attach__XJwLX"};